export default [
  {
    name: 'checkPreBook',
    method: 'post',
    desc: '预订前检查',
    path: '/obt/vehicles/order/checkPreBook',
    params:{
      orderType: null
    }
  },
  {
    name: 'getTkOrder',
    method: 'post',
    desc: '获取可预订的航班列表',
    path: '/obt/getTkOrder',
    params:{

    }
  },
  {
    name: 'queryDayCar',
    method: 'post',
    desc: '日包查询',
    path: '/obt/queryDayCar',
    params:{
      fromAddress: '',
      fromLat: '',
      fromLon: '',
      supportCity: '',
      tripType: '',
      useDays: '',
      useRange: '',
      useTime: '',
      useType: 1,
    }
  },
  {
    name: 'queryCar',
    method: 'post',
    desc: '线包查询',
    path: '/obt/queryCar',
    params: {
      airport:'',
      arriveAddress: '',//到达
      arriveCity: '',
      flightNo: '',
      fromAddress: '',//出发
      fromLat: '', // 出发纬度
      fromLon: '',
      supportCity: '',//用车城市
      toLat: '',//到达纬度
      toLon: '',
      tripType: '',
      useTime: '',//Yyyy-mm-dd hh:mm
      useType: ''//用车类型 3线路包车 4接机 5送机 6接站 7送站 默认3
    }
  },
  {
    name: 'vehicleTypeFindList',
    method: 'post',
    desc: '查询车型列表',
    path: '/obt/vehicleTypeFindList',
    params:{

    }
  },
  {
    name: 'bookCarOrder',
    method: 'post',
    desc: '用车下单接口',
    path: '/obt/bookCarOrder',
    params:{
      'arriveAirport': '',
      'arriveTerminal': '',
      'arriveTime': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'cityId': '',
      'costCenterCode': '',
      'costCenterId': '',
      'costCenterName': '',
      'departAirport': '',
      'departTerminal': '',
      'departTime': '',
      'empId': '',
      'empName': '',
      'endTime': '',
      'flightno': '',
      'fromLat': 0,
      'fromLon': 0,
      'fsEmpId': '',
      'ifSameOrder': '',
      'linkEmail': '',
      'linkTel': '',
      'linkman': '',
      'orderFrom': '',
      'orderType': 0,
      'phoneNumber': '',
      'pnrNo': '',
      'priceFrom': '',
      'priceFromName': '',
      'priceId': '',
      'projectCode': '',
      'projectId': '',
      'projectName': '',
      'rangeType': '',
      'routeId': '',
      'scdd': '',
      'sfbrdc': 0,
      'startTime': '',
      'subjectCode': '',
      'toLat': 0,
      'toLon': 0,
      'tripType': 0,
      'unionOrderId': '',
      'unionOrderType': '',
      'useDays': 0,
      'vehicleProductId': '',
      'vehicleTypeId': '',
      'xcdd': ''
    }
  },
  {
    name: 'vehiclesCityFindList',
    method: 'post',
    desc: '获取用车城市列表',
    path: '/obt/vehiclesCityFindList',
    params:{

    }
  },
  {
    name: 'getTravelPolicy',
    method: 'post',
    desc: '订单列表匹配差旅标准',
    path: '/obt/vehicleClzcDetail',
    params:{
      'empId': '',
      'useTime': '',
      'sycp': '',
      'vehicleTypeId': '',
      'price': null,
      'distance': '',
      'ccsqdNo': ''
    }
  },
  {
    name: 'queryFlightByHbh',
    method: 'post',
    desc: '根据航班号获取航班信息',
    path: '/obt/queryFlightByHbh',
    loading:true,
    params:{
      'arriveAirport': '',
      'departAirport': '',
      // 'departTime': '',
      'flightNo': '',
      'pageNum': 1,
      'count': 160
    }
  },
  {
    name: 'getDriverLocation',
    method: 'post',
    desc: '获取司机位置',
    path: '/obt/getDriverLocation',
    loading:'0',
    params:{

    }
  },
  {
    name: 'queryApTrnInfo',
    method: 'post',
    desc: '获取航站楼信息',
    path: '/obt/queryApTrnInfo',
    params:{
      threeCode:''
    },
    loading:'0'
  },

  /******************用车新接口********************/
  {
    name: 'estimateYyycPrice',
    method: 'post',
    desc: '预约用车预估价查询',
    path: '/obt/vehicles/shopping/estimateYyycPrice',
    params:{
      'tripType': '',
      'departCity': '',
      'arriveCity': '',
      'useDays': 0,
      'useType': 0,
      'vehicleTypeId': '',
      'useAirportOrZd': '',
      'fromAddress': '',
      'fromLon': 0,
      'fromLat': 0,
      'toAddress': '',
      'toLon': 0,
      'toLat': 0,
      'useTime': '',
      'flightNo': '',
      'empId': '',
      'ccsqdNo': '',
      'customerMobile': '',
      'customerName': '',
      'fromLocationName': '',
      'toLocationName': '',
      'departAirport':'',// 出发机场三字码三字码
      'arriveAirport':'',// 到达机场三字码三字码
    }
  },
  {
    name: 'bookYyyc',
    method: 'post',
    desc: '预约用车下单',
    path: '/obt/vehicles/order/bookYyyc',
    params:{
      'cacheId': '',
      'orderFrom': '',
      'unionOrderId': '',
      'unionOrderType': '',
      'pnrNo': '',
      'useType': 0,
      'productId': '',
      'departCity': '',
      'arriveCity': '',
      'departAirport': '',
      'departTerminal': '',
      'departTime': '',
      'flightNo': '',
      'fromAddressPoi': '',
      'fromArea': '',
      'fromAddress': '',
      'fromLon': 0,
      'fromLat': 0,
      'toAddressPoi': '',
      'toArea': '',
      'toAddress': '',
      'toLon': 0,
      'toLat': 0,
      'arriveAirport': '',
      'arriveTerminal': '',
      'arriveTime': '',
      'startTime': '',
      'endTime': '',
      'useDays': 0,
      'empId': '',
      'empName': '',
      'fsEmpId': '',
      'phoneNumber': '',
      'tripType': 1,
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'subjectCode': '',
      'ifSameOrder': '',
      'routeId': '',
      'projectId': '',
      'projectCode': '',
      'projectName': '',
      'costCenterId': '',
      'costCenterCode': '',
      'costCenterName': '',
      'violateitemCode': '',
      'violateitem': '',
      'reasonCode': '',
      'reasonDesc': '',
      'linkman': '',
      'linkTel': '',
      'linkEmail': '',
      //'sfbrdc': 0,
      'booker': '',
      'ext1': ''
    }
  },
  {
    name: 'bookYyycs',
    method: 'post',
    desc: '接送机批量下单接口',
    path: '/obt/vehicles/order/bookYyycs',
    params:{
      'vehiclesReq': [

      ]
    }
      
  },
  {
    name: 'estimateJsycPrice',
    method: 'post',
    desc: '即时用车预估价查询',
    path: '/obt/vehicles/shopping/estimateJsycPrice',
    params: {
      'corpId': null,
      'tripType': null,
      'departCity': null,
      'arriveCity': null,
      'useType': 0, // 用车类型 8即时 9预约
      'vehicleTypeId': null,
      'fromAddress': null,
      'fromLon': 0,
      'fromLat': 0,
      'toAddress': null,
      'toLon': 0,
      'toLat': 0,
      'useTime': undefined,
      'empId': '',
      'ccsqdNo': '',
      'customerMobile': '',
      'customerName': '',
      'fromLocationName': '',
      'toLocationName': '',
    }
  },
  {
    name: 'bookJsyc',
    method: 'post',
    desc: '即时用车下单',
    path: '/obt/vehicles/order/bookJsyc',
    params: {
      'cacheId': null,
      'corpId': null,
      'orderFrom': null,
      'unionOrderId': null,
      'unionOrderType': null,
      'pnrNo': null,
      'productId': null,
      'useType': 0,
      'departCity': null,
      'arriveCity': null,
      'fromAddressPoi': null,
      'fromArea': null,
      'fromAddress': null,
      'fromLon': 0,
      'fromLat': 0,
      'toAddressPoi': null,
      'toArea': null,
      'toAddress': null,
      'toLon': 0,
      'toLat': 0,
      'startTime': null,
      'empId': null,
      'empName': null,
      'fsEmpId': null,
      'phoneNumber': null,
      'tripType': 0,
      'ccsqdId': null,
      'ccsqdNo': null,
      'ccsqdRemark': null,
      'subjectCode': null,
      'ifSameOrder': null,
      'routeId': null,
      'projectId': null,
      'projectCode': null,
      'projectName': null,
      'costCenterId': null,
      'costCenterCode': null,
      'costCenterName': null,
      'violateitemCode': '',
      'violateitem': '',
      'reasonCode': '',
      'reasonDesc': '',
      'linkman': null,
      'linkTel': null,
      'linkEmail': null,
      'sfbrdc': 0,
      'booker': null,
      'ext1': null,
    }
  },
]
